export default function() {

  function check(name,val,exp) {
    if (val != exp) {
      console.warn(name+" Failed");
      console.dir("Got:"+val);
      console.dir("Exp:"+exp);
      alert("check console for mismatch");
    } else {
      console.log(name+" Passed");
    }
  }

  async function test() {
    let val;
    val = await HASH("SHA-256", "the message", "base64");
    check("HASH #1",val,"yZRqB1/Qd93mR2pGaeVDymvNWQZMzBFzR397TJ0AWCU=");
    val = await HASH("SHA-256", "the message", "hex");
    check("HASH #2",val,"c9946a075fd077dde6476a4669e543ca6bcd59064ccc1173477f7b4c9d005825");

    val = await HMAC("secret","the message", "base64");
    check("HMAC #1",val,"IHSbIaVD7bYRGGf7qHzTWgYPGAahUCgAKSoSNDyUub8=");
    val = await HMAC("secret","the message", "hex");
    check("HMAC #2",val,"20749b21a543edb6111867fba87cd35a060f1806a1502800292a12343c94b9bf");

    val = await GetSignatureKey("mutMuLI2Vg2tKpO9OwOCwM6MI8aRpKHuYenCAxA1", "20230303", "us-west-2", "transcribe");
    check("GetSignatureKey #1",toHex(val),"563ba90404ba5e7fe11ff70c56a4755993337787b0c87c6b0913543fa0723ef4");

    let str = ['AWS4-HMAC-SHA256', '20230303T184631Z', '20230303/us-west-2/transcribe/aws4_request', '7e23d21429c69504034d0164a62892955c3a01daeee81ea0f7b9b011c922061a'].join("\n");
    let key = await GetSignatureKey("mutMuLI2Vg2tKpO9OwOCwM6MI8aRpKHuYenCAxA1", "20230303", "us-west-2", "transcribe");
    val = await HMAC(key, str, "hex");
    check("Signing #1",val,"11fc6065dbbc8eedcbc98f84efb757b43870657c8c2e0dbf745bd150d2bcae14");

    val = await HASH("SHA-256", "", "hex");
    check("Payload Hash",val,"e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855");
    
    val = await build_signed_url_transcribe({
      access_key: "AKIA3S2CRCCIFOVGLGER",
      secret: "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",
      datetime: "20230303T184631Z",
      region: "us-west-2",
      stability: "medium",
    });
    check("Transcribe URL",val,"wss://transcribestreaming.us-west-2.amazonaws.com:8443/stream-transcription-websocket?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA3S2CRCCIFOVGLGER%2F20230303%2Fus-west-2%2Ftranscribe%2Faws4_request&X-Amz-Date=20230303T184631Z&X-Amz-Expires=250&X-Amz-SignedHeaders=host&enable-partial-results-stabilization=true&language-code=en-US&media-encoding=flac&partial-results-stability=medium&sample-rate=16000&X-Amz-Signature=80961f80a012c7e684a290159c88eb2b9e5b536a0520deac02f8f51533f01975");

    let hex = "000000c70000006104a2ba6c0f3a657863657074696f6e2d7479706507001342616452657175657374457863657074696f6e0d3a636f6e74656e742d747970650700106170706c69636174696f6e2f6a736f6e0d3a6d6573736167652d74797065070009657863657074696f6e7b224d657373616765223a22596f757220726571756573742074696d6564206f75742062656361757365206e6f206e657720617564696f2077617320726563656976656420666f72203135207365636f6e64732e227d3db9416f";
    streamEventParse(fromHex(hex));
  }


  /**********************************************************************
   * Transcription Class
   **********************************************************************/

  class Transcriber {
    constructor() {
      this.input_sr = 48000;
      this.output_dsf = 6;
      this.output_sr = Math.max(this.input_sr / this.output_dsf, 8000);
      /* Comment out */
      //test();
    }

    set_sample_rate(sr) {
      this.input_sr = 0|sr;
      this.output_sr = Math.max(this.input_sr / this.output_dsf, 8000);
    }

    async open(opt,event_cb) {
      let tr = this;
      tr.event_cb = event_cb || function(){};
      tr.idle = 0;
      tr.cnt = 0;
      tr.sum = 0;
      tr.fltbuf = new Float32Array(tr.input_sr);
      tr.fltbuf_at = 0;
      tr.tm_adj = 0;
      delete tr.txt;
      tr.rms_low = 0;
      tr.tms = [{ep:0,samp:0}];
      tr.tms_samp = 0;
      tr.tms_first_ep = 0;

      //console.log("Transcribe Sample Rate",tr.input_sr,tr.output_sr);
      wss_send_cb(vx, "get_transcribe_auth", {
        cfg: {
          region: "us-west-2",
          encoding: "pcm",
          sr: (""+tr.output_sr),
          // low = high accuracy / less stable
          // medium
          // high = more stable / lower accuracy
          stability: "medium",
          ctm: Date.now(),
          /* Pass in last known values, if any */
          tuid: tr.tuid,
          handle: tr.handle,
        }
      }, async function(msg) {
        if (!msg || !msg.data || !msg.data.url) {
          tr.event_cb({name:"auth-error", error:msg.data.error || "no url"});
          tr.event_cb({name:"close"});
          return;
        }
        tr.isodate = msg.data.isodate;
        tr.expires = msg.data.expires;
        tr.url = msg.data.url;
        tr.tuid = msg.data.tuid;
        tr.handle = msg.data.handle;
        tr.tm_adj = (msg.data.stm - msg.data.ctm);
        //console.log("SYNC",msg.data.ctm, msg.data.stm, tr.tm_adj);
        /* For Testing Only */
        //tr.url = await build_signed_url_transcribe({
        //  access_key: "AKI",
        //  secret: "R7J",
        //  datetime: tr.isodate,
        //  region: msg.data.region,
        //  encoding: msg.data.encoding,
        //  sr: (""+tr.output_sr),
        //  stability: msg.data.stability,
        //});
        //check("URL MATCH",msg.data.url,tr.url);

        tr.event_cb({name:"connecting"});
        tr.wss =  new WebSocket(tr.url);
        tr.wss.binaryType = 'arraybuffer';
        tr.wss.onopen = function(ev) {
          tr.event_cb({name:"open", tuid: tr.tuid});
        }
        tr.wss.onclose = function(ev) {
          tr.event_cb({name:"close"});
        }
        tr.wss.onerror = function(ev) {
          console.log("error",ev);
        }
        tr.wss.onmessage = function(ev) {
          if (typeof ev.data == "string") {
            console.log("msg",ev);
          } else {
            //console.log("bin",ev);
            streamEventParse(new Uint8Array(ev.data), function(headers,payload) {
              tr.processResult(headers, payload);
            });
          }
        }
      }); // wss_send_cb
    }

    close() {
      let tr = this;
      if (!tr.wss) { return; }
      if (tr.closing_wss) {
        /* Already have a draining wss. Immediately close it. */
        delete tr.closing_wss.close();
      }

      /* Send silience to flush out remaining text */
      let msg = streamAudioEventCreate(new Uint8Array(2000));
      tr.wss.send(msg);
      tr.wss.send(msg);
      tr.wss.send(msg);
      tr.wss.send(msg);
      tr.wss.send(msg);

      /* Move to temporary state so that no new samples are sent to
       * it. We want to give it a chance to drain off any already
       * inflight text
       */
      tr.closing_wss = tr.wss;
      delete tr.wss;

      setTimeout(function() {
        console.log("Transcriber draining complete");
        if (tr.closing_wss) {
          tr.closing_wss.close();
        }
        delete tr.closing_wss;
      }, 4000);
    }

    //{Transcript:{Results:[{
    //   Alternatives:[{
    //     Items:[{
    //       Confidence: 0..1,
    //       Content:"Hello",
    //       StartTime:,
    //       EndTime:,
    //       Type:"pronunciation",
    //       VocabularyFilterMatch:false
    //     },{
    //       Content:".",
    //       StartTime:,      
    //       EndTime:,
    //       Type:"punctuation",
    //       VocabularyFilterMatch:false
    //     }],
    //    Transcript:"Hello."
    //   }], //Alt
    //   ChannelId:"ch_0",
    //   StartTime:,
    //   EndTime:,
    //   IsPartial:true,
    //   ResultId:"ab321...",      
    // }] //Res
    //}
    processResult(headers, payload) {
      let tr = this;
      if (headers[":message-type"] == "exception") {
        console.warn("Transcribe Error:",toString(payload));
        return;
      }
      if (headers[":content-type"] != "application/json") {
        //console.log("PAYLEN",payload.byteLength);
        return;
      }
      let j = to_json(toString(payload));
      //console.log("JSON",toString(payload));
      if (!j ||
          !j.Transcript ||
          !j.Transcript.Results ||
          !j.Transcript.Results[0] ||
          !j.Transcript.Results[0].Alternatives ||
          !j.Transcript.Results[0].Alternatives[0]) {
        console.log("TXT --");
        //if (tr.idle++ > 10) {
        //  tr.close();
        //}
        return;
      }
      let rid = j.Transcript.Results[0].ResultId;
      let alt = j.Transcript.Results[0].Alternatives[0];
      //console.log("TXT",alt.Transcript,rid);
      //console.log("TXT",JSON.stringify(alt));
      tr.idle = 0;
      tr.txt = tr.txt || [];
      if (!tr.txt[0] || rid != tr.txt[0].rid) {
        /* New result */
        tr.txt.unshift({});
        tr.txt[0].rid = rid;
        tr.txt[0].parts = [];
      }
      tr.txt[0].script = alt.Transcript;
      tr.txt[0].change = [];
      delete tr.txt[0].st;
      delete tr.txt[0].et;
      let p = 0;
      alt.Items.forEach(function(it) {
        //if (it.Type != "pronunciation") { return; }
        if (it.Stable !== true) { return; }
        if (it.Content != tr.txt[0].parts[p]) {
          if (!tr.txt[0].st) {
            tr.txt[0].st = tr.trans2EpochTime(it["StartTime"]);
          }
          tr.txt[0].parts[p] = it.Content;
          tr.txt[0].change.push(it.Content);
          tr.txt[0].et = tr.trans2EpochTime(it["EndTime"]);
        }
        ++p;
      });
      //console.log("TXT2",JSON.stringify(tr.txt[0]));
      tr.event_cb({name:"txt",txt:tr.txt});
      delete tr.txt[0].change;
    }

    trackTiming(samples) {
      let tr = this;
      let cur = tr.tms[0];
      let now = Date.now();
      if ((now - cur.ep) > 250) {
        tr.tms.unshift({
          ep: now,
          samp: tr.tms_samp,
        });
        cur = tr.tms[0];
        if (!tr.tms_first_ep) {
          tr.tms_first_ep = now;
        }
        //console.log("TIMES",JSON.stringify(tr.tms));
      }
      /* Limit length */
      tr.tms.splice(40);
      tr.tms_samp += samples;
    }

    trans2EpochTime(tm) {
      let tr = this;
      let samp = tm * tr.output_sr;
      let ref, ep;
      for (let i=0; i<tr.tms.length; ++i) {
        ref = tr.tms[i];
        if (samp >= ref.samp) {
          //console.log("SAMP", i, samp, ref.samp, samp-ref.samp, tr.tms[i-1].samp);
          break;
        }
      }
      samp -= ref.samp;
      /* Linear extrapolation plus server time adjustment */
      ep = Math.round(ref.ep + (500 * samp / tr.output_sr));
      //console.log("EP", tm, ref.ep, ep, ep-tr.tms_first_ep, tr.tm_adj);
      return ep + tr.tm_adj;
    }

    sendFLT(lbuf) {
      let tr = this;
      if (!tr.wss || tr.wss.readyState !== 1) {
        return;
      }

      /* Converts FLT32 samples to PCM */
      let flt2 = new Float32Array(lbuf);
      tr.fltbuf.set(flt2, tr.fltbuf_at);
      tr.fltbuf_at += flt2.length;
      /* Aggregate at least 1/8 of a second */
      if (tr.fltbuf_at < (tr.fltbuf.length/8)) {
        return;
      }

      let flen = tr.fltbuf_at;
      if (tr.output_dsf > 1) {
        /* Down sample by Down-Sample-Factor */
        let wr = 0;
        for (let rd=0; rd<tr.fltbuf_at; ) {
          while (rd < tr.fltbuf_at && tr.cnt < tr.output_dsf) {
            tr.sum += tr.fltbuf[rd];
            tr.cnt++;
            rd++;
          }
          if (tr.cnt >= tr.output_dsf) {
            tr.fltbuf[wr] = tr.sum / tr.cnt;
            tr.sum = 0;
            tr.cnt = 0;
            wr++;
          }
        }
        flen = wr;
        /* Partial sum, cnt will carry over to next block */
        //console.log("down",tr.fltbuf_at, flen, tr.cnt);
      }

      /* 16b per sample */
      let pcmlen = 2 * flen;
      let pcm = new Uint8Array(pcmlen);
      let view = new DataView(pcm.buffer);
      let volume = 1;
      let rms = 0;
      for (let i = 0; i < flen; i++) {
        /* 16 Signed, Little Endian */
        view.setInt16(2*i, tr.fltbuf[i] * (0x7FFF * volume), true);
        rms += (tr.fltbuf[i] * tr.fltbuf[i]);
      }
      rms = Math.sqrt(rms/flen);
      tr.fltbuf_at = 0;
      if (false && rms < 0.0015) {
        tr.rms_low++;
        /* Send silence after/near activity because it is important
         *  for delineating phrases. Send occassional silence to
         *  avoid AWS idle timeout. */
        if (tr.rms_low > 9 && (tr.rms_low % 16) != 0) {
          console.log("RMS SKIP",rms);
          return;
        }
      } else {
        tr.rms_low = 0;
      }
      //console.log("RMS",rms);
      tr.trackTiming(flen);
      
      let msg = streamAudioEventCreate(pcm);
      //console.log("send",msg);
      if (tr.wss.bufferedAmount > 8*1024) {
        console.log("backlog",tr.wss.bufferedAmount);
      }
      tr.wss.send(msg);
    }

    sendPCM(data) {
      let tr = this;
      if (!tr.wss || tr.wss.readyState !== 1) {
        //console.log("websocket not open");
        return;
      }
      let msg = streamAudioEventCreate(data);
      tr.wss.send(msg);
    }
  }

  /**********************************************************************
   * Utilities
   **********************************************************************/

  var crcTable;
  function makeCRCTable(){
    var c;
    crcTable = [];
    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        crcTable[n] = c;
    }
  }

  function crc32(data,start,length) {
    if (!crcTable) {
      makeCRCTable();
    }
    var crc = 0 ^ (-1);
    for (var i = start; i < start+length; i++ ) {
      crc = (crc >>> 8) ^ crcTable[(crc ^ data[i]) & 0xFF];
    }
    return (crc ^ (-1)) >>> 0;
  }
  
  function to4B(data,start) {
    return (data[start] << 24 |
            data[start+1] << 16 |
            data[start+2] << 8 |
            data[start+3]);
  }

  function set4B(data,start,value) {
    data[start] = (value >>> 24) & 0xff;
    data[start+1] = (value >>> 16) & 0xff;
    data[start+2] = (value >>> 8) & 0xff;
    data[start+3] = value & 0xff;
  }

  function to2B(data,start) {
    return (data[start] << 8 |
            data[start+1]);
  }

  function set2B(data,start,value) {
    data[start] = (value >>> 8) & 0xff;
    data[start+1] = (value & 0xff);
  }

  function genISODate(date) {
    let isodate = (new Date(date)).toISOString();
    isodate = isodate.split(".")[0].replace(/[\-\:]/g,"")+"Z";
    console.log("ISO",isodate);
    return isodate;
  }

  function getUtf8Bytes(str) {
    return new Uint8Array(
      [...unescape(encodeURIComponent(str))].map(c => c.charCodeAt(0))
    );
  }

  function toHex(buf) {
    return [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, '0')).join('');
  }

  function fromHex(str) {
    return Uint8Array.from(str.match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));
  }

  function tob64(buf) {
    return btoa(String.fromCharCode(...new Uint8Array(buf)));
  }

  function toString(buf) {
    return String.fromCharCode(...new Uint8Array(buf));
  }

  /**********************************************************************
   * Crypto Utilities
   **********************************************************************/

  //echo -en "the message" | openssl sha256 -hmac "secret" -binary | base64
  //IHSbIaVD7bYRGGf7qHzTWgYPGAahUCgAKSoSNDyUub8=
  async function HMAC(key, msg, kind) {
    let keyBytes = key;
    if (typeof key == "string") {
      keyBytes = getUtf8Bytes(key);
    }
    const messageBytes = getUtf8Bytes(msg);
    const c = await crypto.subtle.importKey('raw', keyBytes, { name: 'HMAC', hash: 'SHA-256' }, true, ['sign']);
    const sig = await crypto.subtle.sign('HMAC', c, messageBytes);

    if (kind == "base64") {
      return tob64(sig);
    } else if (kind == "hex") {
      return toHex(sig);
    } else if (kind == "buffer") {
      return sig;
    }
    return null;
  }

  //echo -en "the message" | openssl sha256 -binary | base64
  //yZRqB1/Qd93mR2pGaeVDymvNWQZMzBFzR397TJ0AWCU=
  async function HASH(algorithm, msg, kind) {
    const messageBytes = getUtf8Bytes(msg);

    const dig = await crypto.subtle.digest(algorithm, messageBytes);

    if (kind == "base64") {
      return tob64(dig);
    } else if (kind == "hex") {
      return toHex(dig);
    } else if (kind == "buffer") {
      return dig;
    }
    return null;
  }
  
  /*************************************************************
   * AWS Transcribe Framing 
   * [4B Total Z] [4B Header Z][P-CRC] [Headers][Payload][M-CRC]
   *  P-CRC covers Total/Header Z
   *  M-CRC covers everything (except M-CRC)
   *
   * Header
   *   [1B Name Z][ Name ][1B Type][2B Value Z][Value]
   */

  function streamEventParse(data, cb) {
    let idx = 0;
    let totalz, headerz;

    totalz = to4B(data,idx); idx += 4;
    //console.log("TZ",totalz);
    headerz = to4B(data,idx); idx += 4;
    //console.log("HZ",headerz);
    //console.log("CRC",to4B(data,idx),crc32(data,0,8));
    idx += 4;

    let header_start = idx;
    let headers = {};
    while (idx < header_start + headerz) {
      //console.log("@",idx);
      let hz = data[idx];
      //console.log("HZ",hz);
      idx += 1;
      let hname = toString(data.slice(idx,idx+hz));
      //console.log("H",hname);
      idx += hz;
      // type-7 appears to be UTF-8
      //console.log("HT",data[idx]);
      idx += 1;
      let hvz = to2B(data,idx); idx += 2;
      //console.log("HVZ",hvz);
      let hval = toString(data.slice(idx,idx+hvz));
      headers[hname] = hval;
      //console.log("HV",hval);
      idx += hvz;
    }
    //console.log("@",idx);
    cb && cb(headers, data.slice(idx,totalz-4));
    //console.log("CRC",to4B(data,totalz-4),crc32(data,0,totalz-4));
    /*
    if (headers[":content-type"] == "application/json") {
      let j = to_json(toString(data.slice(idx,totalz-4)));
      if (headers[":event-type"] == "TranscriptEvent") {
        //console.log("JSON",j);
        if (j && j.Transcript && j.Transcript.Results &&
            j.Transcript.Results[0] &&
            j.Transcript.Results[0].Alternatives &&
            j.Transcript.Results[0].Alternatives[0]) {
          console.log("TXT",j.Transcript.Results[0].Alternatives[0].Transcript);
        }
      } else if (headers[":message-type"] == "exception") {
        console.warn("Transcribe Error:",j);
      }
    } else {
      console.log("PAYLEN",totalz-4-idx);
    }
    */
  }

  function streamBuildHeader(hname, htype, hvalue) {
    let bname = getUtf8Bytes(hname);
    let bvalue = getUtf8Bytes(hvalue);
    let z = 1 + bname.byteLength + 1 + 2 + bvalue.byteLength;
    let data = new Uint8Array(z);
    let idx = 0;
    data[idx] = bname.byteLength; idx++;
    data.set(bname,idx); idx += bname.byteLength;
    data[idx] = htype; idx++;
    set2B(data,idx,bvalue.byteLength); idx += 2;
    data.set(bvalue, idx);
    //console.log(data);
    return data;
  }

  function streamAudioEventCreate(payload) {
    let h1 = streamBuildHeader(":content-type", 7, "application/octet-stream");
    let h2 = streamBuildHeader(":event-type", 7, "AudioEvent");
    let h3 = streamBuildHeader(":message-type", 7, "event");
    let headerz = h1.byteLength + h2.byteLength + h3.byteLength;
    let totalz = 4+4+4 + headerz + payload.byteLength + 4;
    let data = new Uint8Array(totalz);
    let idx = 0;
    set4B(data,idx,totalz); idx += 4;
    set4B(data,idx,headerz); idx += 4;
    //console.log("CRC",crc32(data,0,8));
    set4B(data,idx,crc32(data,0,8)); idx += 4;
    data.set(h1, idx); idx += h1.byteLength;
    data.set(h2, idx); idx += h2.byteLength;
    data.set(h3, idx); idx += h3.byteLength;
    data.set(payload, idx); idx += payload.byteLength;
    set4B(data,idx,crc32(data,0,totalz-4)); idx += 4;
    //console.log("create",idx,data.byteLength);
    //streamEventParse(data);
    return data;
  }

  /**********************************************************************
   * AWS V4 Signing
   **********************************************************************/

  async function GetSignatureKey(secret, datestamp, region, service) {
    let v4Identifier = 'aws4_request';
    let kDate = await HMAC(
      'AWS4' + secret,
      datestamp,
      'buffer'
    );
    //console.log("kDate",new Uint8Array(kDate));
    let kRegion = await HMAC(kDate, region, 'buffer');
    //console.log("kRegion",new Uint8Array(kRegion));
    let kService = await HMAC(kRegion, service, 'buffer');
    //console.log("kService",new Uint8Array(kService));
    let signingKey = await HMAC(kService, v4Identifier, 'buffer');
    //console.log("signingKey", new Uint8Array(signingKey));
    return signingKey;
  }

  /*
    url=
    (`wss://transcribestreaming.${region}.amazonaws.com:8443/`+
    `stream-transcription-websocket?`+
    `&X-Amz-Algorithm=AWS4-HMAC-SHA256`+
    `&X-Amz-Credential=${access_key}%2F${date_YYYYMMDD}%2F${region}%2Ftranscribe%2Faws4_request`+
    `&X-Amz-Date=${date_YYYYMMDDHHMMSS}`+
    `&X-Amz-Expires=${expire}`+
    `&X-Amz-Security-Token=${secret}`+
    `&X-Amz-Signature=${sig}`+
    `&X-Amz-SignedHeaders=content-type%3Bhost%3Bx-amz-date`+
    `&language-code=en-US`+
    `&media-encoding=${encoding}`+
    `&sample-rate=${sr}`
    );
  */
  async function build_signed_url_transcribe(opt) {
    let date_YYYYMMDDHHMMSS = opt.datetime;
    let date_YYYYMMDD = opt.datetime.substr(0, 8);
    let region = opt.region;
    let encoding = opt.encoding || 'flac';
    let sr = opt.sr || 16000;
    let expire = 250;
    let method = "GET";
    let service = "transcribe";
    let endpoint = `wss://transcribestreaming.${region}.amazonaws.com:8443`;
    let host = `transcribestreaming.${region}.amazonaws.com:8443`;
    let amzdate = date_YYYYMMDDHHMMSS;
    let datestamp = date_YYYYMMDD;
    let canonical_uri = "/stream-transcription-websocket";
    let canonical_headers = "host:" + host + "\n";
    let signed_headers = "host";
    let algorithm = "AWS4-HMAC-SHA256";

    let credential_scope = datestamp + "/" + region + "/" + service + "/" + "aws4_request";
    //console.log("credential_scope",credential_scope);

    let canonical_querystring  = "X-Amz-Algorithm=" + algorithm;
    canonical_querystring += "&X-Amz-Credential="+ encodeURIComponent(opt.access_key + "/" + credential_scope);
    canonical_querystring += "&X-Amz-Date=" + amzdate;
    canonical_querystring += "&X-Amz-Expires="+expire;
    //canonical_querystring += "&X-Amz-Security-Token=" + token;
    canonical_querystring += "&X-Amz-SignedHeaders=" + signed_headers;
    /* Note: query args must be ALPHABETICAL for signing */
    //canonical_querystring += `&language-code=en-US&media-encoding=${encoding}&sample-rate=${sr}`;
    canonical_querystring += `&enable-partial-results-stabilization=true&language-code=en-US&media-encoding=${encoding}&partial-results-stability=${opt.stability}&sample-rate=${sr}`;
    //console.log("canonical_querystring",canonical_querystring);

    /* Empty payload since it is a GET */
    let payload_hash = await HASH("SHA-256", "", "hex");
    //console.log("payload_hash",payload_hash);

    let canonical_request =
        (method + '\n' 
         + canonical_uri + '\n' 
         + canonical_querystring + '\n' 
         + canonical_headers + '\n' 
         + signed_headers + '\n' 
         + payload_hash);
    //console.log("canonical_request",canonical_request);

    let canonical_hash = await HASH("SHA-256", canonical_request, "hex");
    //console.log("canonical_hash", canonical_hash);

    let string_to_sign =
        (algorithm + "\n"
         + amzdate + "\n"
         + credential_scope + "\n"
         + canonical_hash);

    let signing_key = await GetSignatureKey(opt.secret, datestamp, region, service);

    let signature = await HMAC(signing_key, string_to_sign, "hex");
    //console.log(signature);
    canonical_querystring += "&X-Amz-Signature=" + signature;

    let request_url = endpoint + canonical_uri + "?" + canonical_querystring;
    //console.dir(request_url);
    return request_url;
  }

  return {
    test: test,
    Transcriber: Transcriber,
  };
}
